// Shared Snowflake validation — Discord IDs are 17-20 decimal digits.
// Trims whitespace; single import replaces duplicated isSnowflake/isSnowflakeId.

export function isSnowflake(id: string): boolean {
  const t = id.trim();
  if (t.length < 17 || t.length > 20) return false;
  for (let i = 0; i < t.length; i++) {
    const c = t.charCodeAt(i);
    if (c < 48 || c > 57) return false;
  }
  return true;
}
